export default "__VITE_ASSET__Cqvuhzvn__"